var scrolling = require('scrolling');
var hasTouch = require('detect-touch').hasTouch;

var $body = document.body,
    $html = document.documentElement,
    winHeight = window.innerHeight,
    $articles = document.querySelectorAll('.fjs-in-viewport');

function scroll(e) {
	for(var i = 0; i < $articles.length; i++) {
		var $article = $articles[i],
			visible = isElementInViewport($article),
			atEnd = isElementAtEnd($article),
			$video = $article.querySelector('.fjs-play-on-scroll');
		
		if($video) {
			$video.pause();
		}

		if(visible) {
			$article.classList.add('js-is-fixed');

			if($video) {
				var $parent = $video.parentElement.parentElement,
					parentOffset = $parent.offsetTop,
					parentHeight = $parent.clientHeight,
					scrollPos = window.pageYOffset || document.documentElement.scrollTop;
				
				var videoDuration = $video.duration;
				if(!isNaN(videoDuration)) {
					$video.pause();
					$video.currentTime = (videoDuration / parentHeight * (scrollPos - parentOffset)) * 1.3;
				}

			}

		} else {
			$article.classList.remove('js-is-fixed');
		}

		if(atEnd) {
			var $video = $article.querySelector('.fjs-play-on-scroll');
			$article.classList.add('js-is-at-end');
			if($video) {
				$video.pause();
			}
		} else {
			$article.classList.remove('js-is-at-end');
		}
	}
	
}
	
// if($videoOnScroll.length) {
// 	for(var i = 0; i < $videoOnScroll.length; i++) {
// 		var $video = $videoOnScroll[i],
// 			videoDuration = $video.duration,
// 			parentHeight = $video.parentElement.parentElement.clientHeight;
		    
// 		    var frameNumber = window.pageYOffset - parentHeight / 1000;
// 		    $video.currentTime = frameNumber;
// 		    window.requestAnimationFrame(scrollPlay);

// 		console.log(parentHeight);

// 	}
// }

if(hasTouch) {
	document.addEventListener("touchmove", scroll, {passive: false});
	scrolling(window, scroll);
} else {
	console.log('test');
	scrolling(window, scroll);
}

function isElementInViewport(el) {
	var rect = el.getBoundingClientRect();


	return (
		rect.top <= 0
	);
}

function isElementAtEnd(el) {
    var rect = el.getBoundingClientRect();
	
	if(hasTouch) {
	    return (
			rect.bottom <= winHeight + 70
		);
	} else {
	    return (
			rect.bottom <= winHeight
		);
	}

    return (
		rect.bottom <= winHeight
	);
}
